export function parallax() {
    const $window = $(window);
    const body = $("body");
    const bodyHeight = body.outerHeight();
    const $parallax = $(".has-parallax");

    $window.on("load scroll", function () {
        let scrollTop = $window.scrollTop();
        $parallax.each(function () {
            let $this = $(this);
            let itemTop = $this.offset().top;
            let speed = -($this.data("speed") || 10);

            $this.css({'transform': 'translateY(' + (scrollTop - itemTop)  / speed + 'px' + ')'});

            if ($this.hasClass('rotate')) {
                $this.css({'transform': 'translateY(' + (scrollTop - itemTop) / speed + 'px' + ') rotate(' + (scrollTop / bodyHeight * 360) + 'deg' + ')'});
            }

            // if (window.innerWidth < 1200) {
            //     $this.css({"transform": "none"});
            // }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js